import React, { useEffect, useState } from 'react';
import { Phone } from 'lucide-react';
import { openCalendly } from '../lib/analytics';

/**
 * Persistent bottom-of-screen CTA. Appears after a modest scroll and
 * on mobile stays sticky; on desktop it drops in from the bottom right.
 */
const StickyCTA = ({ source = 'sticky_cta' }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <>
      {/* Mobile: full-width bottom bar */}
      <div
        className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-background/95 backdrop-blur border-t border-border p-3 shadow-2xl"
        data-testid="sticky-mobile-cta"
      >
        <button
          onClick={() => openCalendly(source + '_mobile')}
          className="w-full flex items-center justify-center gap-2 bg-primary hover:bg-[hsl(var(--brand-hover))] text-primary-foreground font-semibold px-4 py-3 rounded-lg"
        >
          <Phone className="w-4 h-4" />
          Book a Free Strategy Call
        </button>
      </div>

      {/* Desktop: pill in bottom-right */}
      <button
        onClick={() => openCalendly(source + '_desktop')}
        data-testid="sticky-desktop-cta"
        className="hidden md:flex fixed bottom-6 left-6 z-40 items-center gap-2 bg-primary hover:bg-[hsl(var(--brand-hover))] text-primary-foreground font-semibold px-5 py-3 rounded-full shadow-xl shadow-primary/30 btn-brand-glow"
      >
        <Phone className="w-4 h-4" />
        <span>Book a Free Strategy Call</span>
      </button>
    </>
  );
};

export default StickyCTA;
